import * as React from "react";
import { AppFooter } from "@duosoftbg/nacid-frontoffice-components";

const Footer = () => {
  return <AppFooter />;
};
export default Footer;
